module.exports = __webpack_public_path__ + "img/LogoMariano.bb40772b.png";